export const colors = {
  blue: '#4480C5',
  blueGray: '#9EB8DC',
  blueMedium: '#1D5297',
  blueDark: '#16437E',
  blueLight: '#B9D0EF',
  blueWhite: '#4480C570',
  brow: '#835826',
  gray: '#8A8A8A',
  grayBlue: '#B4C6D1',
  grayDark: '#333333',
  grayLight: '#ECECEC',
  green: '#51C99C',
  orange: '#FF6A17',
  white: '#FFFFFF',
  whiteGray: '#F1F6FB',
  whiteBlue: '#DFECFF',
};

export const buttons = {
  bgColor: colors.blue,
  bgHover: colors.orange,
  text: colors.whiteGray,
};

export const theme = {
  background: colors.whiteGray,
};
